import React, { useCallback, useState, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import FormModal from './FormModal/FormModal';
import T from '../../../../common/components/T';
import FormInput from '../form-input/FormInput/FormInput';
import UserContext from '../../../../common/utils/getContext';

const FormChangeDataInModal = (props) => {
    const { attribute, hint, placeholder, required, title, compStyle, value, type, customData } = props;
    const { userToken } = useContext(UserContext);
    const { modalSendUrl, modalSendMethod } = customData;
    const [open, setOpenModal] = useState(false);
    const formOptions = useMemo(
        () => (customData?.formModal?.options ? customData.formModal.options(attribute, placeholder, required, hint, value) : []),
        [customData?.formModal, attribute, placeholder, required, hint, value]
    );
    const setOpen = useCallback((value) => {
        setOpenModal(value);
    }, []);
    const formModalConfig = useMemo(
        () => ({
            attribute,
            options: formOptions,
            modalStyles: compStyle?.modalStyles || {},
            modalSendUrl,
            modalSendMethod,
            modalAfterSendFunc: customData?.modalAfterSend,
            modalTitle: title,
            titlePopup: '',
            message: customData?.message,
            setOpen: setOpen,
            userToken,
            buttonText:
                type === 'password-change-widget' ? (
                    <T textName='change' defaultStr='Изменить' page='all' />
                ) : (
                    <T textName='save' defaultStr='Сохранить' page='all' />
                ),
            cancelFuncs: { web: { onClick: () => setOpen(false) } },
            ...(customData?.formModal?.addedData ? customData?.formModal?.addedData : {})
        }),
        [customData, compStyle, attribute, formOptions, modalSendUrl, modalSendMethod, title, setOpen, userToken, type]
    );
    return (
        <>
            <FormInput
                {...props}
                disabled={true}
                attribute={`${attribute}_field`}
                buttons={{
                    modal: { icon: 'pen-field', handler: () => setOpen(!open) }
                }}
            />
            {!!open && <FormModal {...formModalConfig} />}
        </>
    );
};
FormChangeDataInModal.propTypes = {
    attribute: PropTypes.string,
    hint: PropTypes.node,
    placeholder: PropTypes.node,
    required: PropTypes.bool,
    title: PropTypes.node,
    compStyle: PropTypes.object,
    value: PropTypes.string,
    type: PropTypes.string,
    customData: PropTypes.object
};
export default FormChangeDataInModal;
